import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import ManageRoster from '../../Form/ManageRoster'
import {
  addStudent,
  deleteStudent,
  addCourse,
  deleteCourse,
  updateStudent,
  updateCourse,
  selectAllStudents,
} from '../../../../reducers/seriesReducer'

const ManageSeriesRoster = () => {
  const { t } = useTranslation()
  const { courses, students } = useSelector(state => state.series)
  const allStudents = useSelector(selectAllStudents)

  return (
    <ManageRoster
      type='EventRoster'
      title={t('events.seriesFlow.manageSeriesRoster.title')}
      selectedStudents={allStudents}
      getSelectedStudent={id => students.entities[id]}
      getSelectedProgram={id => courses.entities[id]}
      addStudentCallback={addStudent}
      deleteStudentCallback={deleteStudent}
      addProgramCallback={addCourse}
      deleteProgramCallback={deleteCourse}
      updateStudentCallback={updateStudent}
      updateProgramCallback={updateCourse}
    />
  )
}

export default ManageSeriesRoster
